import type { CheckoutEstimateReturnRequestDto, CheckoutEstimateResultDto } from "../generated/schema";
import { getReturnWidgetFetchClient } from "./return-widget-client";
import { usePublicApiMutation } from "./use-public-api-mutation";
import { SESSION_TOKEN_KEY } from "./use-session-token";

const authHeader = () => ({ authorization: `Bearer ${localStorage.getItem(SESSION_TOKEN_KEY) ?? ""}` });

export async function publicCheckoutEstimate(
	body: CheckoutEstimateReturnRequestDto,
): Promise<CheckoutEstimateResultDto> {
	const { data, error } = await getReturnWidgetFetchClient().POST(
		"/public/return-request/checkout/estimate",
		{ params: { header: authHeader() }, body },
	);
	if (error) throw error;
	return data;
}

export function usePublicCheckoutEstimate() {
	return usePublicApiMutation(
		"post",
		"/public/return-request/checkout/estimate",
		{
			mapVariables: (body: CheckoutEstimateReturnRequestDto) => ({
				params: { header: authHeader() },
				body,
			}),
		},
	);
}
